module.exports = __webpack_public_path__ + "static/media/tiktok.5c58cf4f.svg";